import api from "./base-api"

const dsPlayerEventApiV1 = api.injectEndpoints({
    endpoints: (build) => ({
        getPlayerEventsV1Ds: build.query({
            query: ({
                userId = "",
                from,
                to
            }) => `v1/ds/player-events/${userId}?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`,
            keepUnusedDataFor: 300
        })
    }),
    overrideExisting: false
})

export const {
    useGetPlayerEventsV1DsQuery
} = dsPlayerEventApiV1
